import { render } from "./SocialSection.vue?vue&type=template&id=86d54320"
const script = {}

import "./SocialSection.vue?vue&type=style&index=0&id=86d54320&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__